(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zy-blog-post-share-js"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const shareButton = document.querySelector('[data-share-button]');
    const shareFeedback = document.querySelector('[data-share-feedback]');

    if (!shareButton) return;

    async function copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }

      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        document.body.removeChild(textArea);
        return true;
      } catch (error) {
        document.body.removeChild(textArea);
        return false;
      }
    }

    async function handleShare() {
      const url = shareButton.dataset.shareUrl;
      const title = shareButton.dataset.shareTitle;
      const text = shareButton.dataset.shareText;
      const msgOk = shareButton.dataset.msgSuccess;
      const msgErr = shareButton.dataset.msgError;
      const msgCopied = shareButton.dataset.msgCopied;
      const msgCpErr = shareButton.dataset.msgCopyError;

      if (navigator.share) {
        try {
          await navigator.share({ title, text, url });
          if (shareFeedback) shareFeedback.textContent = msgOk;
        } catch (error) {
          if (shareFeedback) shareFeedback.textContent = error.name !== 'AbortError' ? msgErr : '';
        }
        return;
      }

      const copied = await copyToClipboard(url);
      if (shareFeedback) shareFeedback.textContent = copied ? msgCopied : msgCpErr;
    }

    shareButton.addEventListener('click', handleShare);

    shareButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleShare();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
